module.exports = __webpack_public_path__ + "static/media/19ESCAP43.71e11688.jpg";